import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../types/i18n.ts'
import { normalizeLanguage } from '../utils/langPath.ts'

i18n
	.use(Backend)
	.use(initReactI18next)
	.init({
		lng: normalizeLanguage(window.location.pathname.split('/')[1]),
		fallbackLng: DEFAULT_LANGUAGE,
		supportedLngs: SUPPORTED_LANGUAGES,
		defaultNS: 'common',
		ns: ['common', 'home', 'pricing', 'faq', 'contact', 'planner', 'reviews', 'legal'],

		backend: {
			loadPath: '/locales/{{lng}}/{{ns}}.json'
		},

		interpolation: {
			escapeValue: false
		},

		react: {
			useSuspense: true
		}
	})

export default i18n
